(function () {
  if (customElements.get('m-homepage-multibanner')) return;

  class HomepageMultibanner extends HTMLElement {
    connectedCallback() {
      this.mobileTimers = new Map();
      this.onResize = this.refreshMobileOverlays.bind(this);
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize);
      this.init();
    }

    disconnectedCallback() {
      this.clearMobileTimers();
      if (this.slider) this.slider.destroy(true, true);
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.onResize);
    }

    init() {
      const container = this.querySelector('.swiper-container');
      if (!container || !window.MinimogLibs || !window.MinimogLibs.Swiper) return;
      if (container.swiper) container.swiper.destroy(true, true);

      const slides = Number(this.dataset.slideCount || 0);
      const desktopItems = Number(this.dataset.desktopItems || 3);
      const tabletItems = Number(this.dataset.tabletItems || 2);
      const mobileItems = Number(this.dataset.mobileItems || 1);
      const loopEnabled = this.dataset.loop === 'true' && slides > desktopItems;
      const autoplayEnabled = this.dataset.autoplay === 'true';
      const speed = Number(this.dataset.speed || 5000);
      const gap = Number(this.dataset.gap || 16);

      this.slider = new MinimogLibs.Swiper(container, {
        slidesPerView: mobileItems,
        spaceBetween: gap,
        loop: loopEnabled,
        watchOverflow: true,
        threshold: 2,
        autoplay: autoplayEnabled ? { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        pagination: this.dataset.pagination === 'true' ? {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        } : false,
        navigation: this.dataset.navigation === 'true' ? {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        } : false,
        breakpoints: {
          768: { slidesPerView: tabletItems, spaceBetween: gap },
          1024: { slidesPerView: desktopItems, spaceBetween: gap }
        },
        on: {
          init: () => {
            this.resetVideoSound();
            this.refreshMobileOverlays();
          },
          slideChangeTransitionStart: () => {
            this.resetVideoSound();
            this.refreshMobileOverlays();
          }
        }
      });

      this.resetVideoSound();
      this.refreshMobileOverlays();
    }

    resetVideoSound() {
      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
      });

      this.querySelectorAll('[data-video-sound-toggle]').forEach((button) => {
        button.dataset.muted = 'true';
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', 'Unmute video');
      });
    }

    handleClick(event) {
      const soundButton = event.target.closest('[data-video-sound-toggle]');
      if (soundButton && this.contains(soundButton)) {
        event.preventDefault();
        event.stopPropagation();

        const card = soundButton.closest('.m-homepage-multibanner__card');
        const video = card ? card.querySelector('video') : null;
        if (!video) return;

        video.muted = !video.muted;
        soundButton.dataset.muted = String(video.muted);
        soundButton.setAttribute('aria-pressed', String(!video.muted));
        soundButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');

        if (!video.muted) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        }
        return;
      }

      const contentButton = event.target.closest('[data-content-toggle]');
      if (!contentButton || !this.contains(contentButton)) return;

      event.preventDefault();
      event.stopPropagation();

      const card = contentButton.closest('.m-homepage-multibanner__card');
      if (!card) return;

      const collapsed = card.classList.toggle('is-content-collapsed');
      contentButton.setAttribute('aria-expanded', String(!collapsed));
      contentButton.setAttribute('aria-label', collapsed ? 'Raise card content' : 'Lower card content');

      const timer = this.mobileTimers.get(card);
      if (timer) {
        window.clearTimeout(timer);
        this.mobileTimers.delete(card);
      }
    }

    clearMobileTimers() {
      this.mobileTimers.forEach((timer) => window.clearTimeout(timer));
      this.mobileTimers.clear();
    }

    refreshMobileOverlays() {
      this.clearMobileTimers();

      const cards = this.querySelectorAll('.m-homepage-multibanner__card');
      cards.forEach((card) => {
        card.classList.remove('is-content-collapsed');
        const toggle = card.querySelector('[data-content-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          toggle.setAttribute('aria-label', 'Lower card content');
        }
      });

      if (!window.matchMedia('(max-width: 767px)').matches) return;

      cards.forEach((card) => {
        const behavior = card.dataset.mobileOverlay;
        if (behavior !== 'collapse_arrow' && behavior !== 'compact_button_arrow') return;

        const delay = Math.max(1000, Number(card.dataset.mobileOverlayDelay || 4000));
        const timer = window.setTimeout(() => {
          card.classList.add('is-content-collapsed');
          const toggle = card.querySelector('[data-content-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Raise card content');
          }
          this.mobileTimers.delete(card);
        }, delay);

        this.mobileTimers.set(card, timer);
      });
    }
  }

  customElements.define('m-homepage-multibanner', HomepageMultibanner);
})();
